module.exports = new __parcel__URL__("HierarchyIllustration.5acb9c37.svg").toString();